import { render, staticRenderFns } from "./PackageCalibrate.vue?vue&type=template&id=2f9ad96c&scoped=true"
import script from "./PackageCalibrate.vue?vue&type=script&lang=js"
export * from "./PackageCalibrate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9ad96c",
  null
  
)

export default component.exports